module.exports = __webpack_public_path__ + "static/media/spIcon.bc9f4caa.svg";